import Page from "components/Page";
import PageBody from "components/PageBody";
import DashboardPageHead from "./DashboardPageHead";
import MyPublications from "./MyPublications";
import { useMyPublicationsSummary, useMyRecentPublications } from "containers/Reporting/_hooks";

export default function MyPublications_TMP() {
    const { isLoading: myPublicationsSummaryLoading, data: myPublicationsSummary } = useMyPublicationsSummary();
    const { isLoading: myRecentPublicationsLoading, data: myRecentPublications } = useMyRecentPublications();
    return (
        <Page>
            <DashboardPageHead breadcrumb={[{ name: "Publications" }]} />
            <PageBody>
                <MyPublications myPublicationsSummaryLoading={myPublicationsSummaryLoading} myPublicationsSummary={myPublicationsSummary} myRecentPublicationsLoading={myRecentPublicationsLoading} myRecentPublications={myRecentPublications} />
            </PageBody>
        </Page>
    );
}
